import React from "react";

export const Team = (props) => {
  return (
    <div id={props.data ? props.data.main.toLowerCase().replace(/ /g, "_") : "loading..."} className="text-center team">
      <div className="container">
        <div className="row">
          <div className="col-md-12 section-title">
            <h2> {props.data ? props.data.main : "Loading"}</h2>
          </div>
          <div className="row">
            {props.data
              ? props.data.paragraphs.map((d, i) => (
                <div key={`${i}`} className="col-md-12">
                  {" "}
                  <p>{d}</p>
                </div>
              ))
              : "Loading..."}
          </div>
        </div>
        <div className="row">
          {props.data
            ? props.data.members.map((d, i) => (
              <div key={`${d.name}-${i}`} className="col-md-4 col-sm-6">
                <div className="thumbnail">
                  {" "}
                  <img src={d.img} alt={d.name} className="team-img" />
                  <div className="caption">
                    <h4>{d.name}</h4>
                    <p>{d.job}</p>
                  </div>
                </div>
              </div>
            ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
